import { isBridgeMessage, WebIpcBridge } from './web-ipc-bridge'

type WindowMessageEvent = { origin: string; data: unknown; source: unknown }

export type WebBridgeWindow = {
    opener: { postMessage(message: unknown, targetOrigin: string): void } | null
    addEventListener(type: 'message', handler: (event: WindowMessageEvent) => void): void
    document: Pick<Document, 'createElement' | 'body'>
    URL: Pick<typeof URL, 'createObjectURL' | 'revokeObjectURL'>
}

const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
// 즉시 해제하면 일부 브라우저에서 다운로드가 시작 전에 취소된다
const REVOKE_OBJECT_URL_DELAY_MS = 1000

const downloadWith = (win: WebBridgeWindow) => (fileName: string, data: BlobPart): void => {
    const blob = new Blob([data], { type: XLSX_MIME_TYPE })
    const url = win.URL.createObjectURL(blob)
    const anchor = win.document.createElement('a')
    anchor.href = url
    anchor.download = fileName
    win.document.body.appendChild(anchor)
    anchor.click()
    win.document.body.removeChild(anchor)
    setTimeout(() => win.URL.revokeObjectURL(url), REVOKE_OBJECT_URL_DELAY_MS)
}

/** 웹(비운영)에서 opener 창과 통신하는 브리지. 조건이 안 맞으면 undefined (기존 no-op 동작 유지) */
export const createWebBridge = (win: WebBridgeWindow, allowedOrigins: string[]): WebIpcBridge | undefined => {
    const opener = win.opener
    if (opener == undefined || allowedOrigins.length === 0) { return undefined }
    const bridge = new WebIpcBridge({ opener, allowedOrigins, download: downloadWith(win) })
    win.addEventListener('message', event => {
        // 같은 origin 의 다른 창이 보낸 메시지를 막기 위해 opener 창이 보낸 것만 받는다
        if (event.source !== opener) {
            if (isBridgeMessage(event.data)) {
                console.warn('[WebIpcBridge] ignored message from non-opener window')
            }
            return
        }
        bridge.receive(event)
    })
    return bridge
}
